import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SANDBOX_SOURCE_PARAM } from '../constants/knowledge.js';

/**
 * Drive's "View claims" lands on the Sandbox with `?source=<fileId>` (CT-5718).
 * Applies that file once as the Source filter, then drops the param, so the
 * filter is the user's to clear and a reload does not re-apply it.
 */
export function useDriveSourceFilter(setFilter) {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedSource = searchParams.get(SANDBOX_SOURCE_PARAM);
  const [handledSource, setHandledSource] = useState(null);

  // During render, not in an effect: the first request already carries the filter.
  if (requestedSource && requestedSource !== handledSource) {
    setHandledSource(requestedSource);
    setFilter('source', [requestedSource]);
  }

  useEffect(() => {
    if (!requestedSource) return;
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete(SANDBOX_SOURCE_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [requestedSource, setSearchParams]);
}

export default useDriveSourceFilter;
